module.exports = __webpack_public_path__ + "static/media/star.7142f48f.svg";